// infcode_change - new file
export namespace TlsPolicy {
  export type Env = Record<string, string | undefined>

  export function rejectUnauthorized(env: Env = process.env): boolean {
    if (env.INFCODE_STRICT_TLS === "1") return true
    const value = env.NODE_TLS_REJECT_UNAUTHORIZED
    return value ? value !== "0" : false
  }
}
